import React from "react";
import sanitizeHtml from "sanitize-html";

type Props = {
  html: string;
  className?: string;
  component?: keyof JSX.IntrinsicElements;
};

const SANITIZE_OPTIONS: sanitizeHtml.IOptions = {
  allowedTags: ["p", "br", "strong", "b", "em", "i", "u", "ol", "ul", "li"],
  allowedAttributes: {},
};

const HtmlText: React.VFC<Props> = ({ html, className, component: Tag = "div" }) => {
  if (!html) return null;
  return (
    <Tag
      className={className}
      dangerouslySetInnerHTML={{
        __html: sanitizeHtml(html, SANITIZE_OPTIONS),
      }}
    />
  );
};

export default React.memo(HtmlText);
